import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Offcanvas } from '@/entities/offcanvas'
import { EditDishForm } from '@/features/dish'
import { useRouteOffcanvas } from '@/shared/hooks/use-route-offcanvas'

export const Route = createFileRoute('/_auth/canteen/menu-settings/dishes/update/$dishId')({
  component: RouteComponent,
})

function RouteComponent() {
  const { isOpen, close } = useRouteOffcanvas('../..')
  const { t } = useTranslation()
  const { dishId } = Route.useParams()

  return (
    <Offcanvas open={isOpen} onClose={close} title={t('Редактирование блюда')}>
      <EditDishForm dishId={dishId} onClose={close} />
    </Offcanvas>
  )
}
